import { useCallback, useEffect, useRef, useState } from 'react';

const useTimedNotification = (duration = 3000) => {
    const [notification, setNotification] = useState(null);
    const timeoutRef = useRef(null);

    const showNotification = useCallback((message, type = 'error') => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        setNotification({ message, type });
        timeoutRef.current = setTimeout(() => {
            setNotification(null);
            timeoutRef.current = null;
        }, duration);
    }, [duration]);

    useEffect(() => () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    }, []);

    return {
        notification,
        showNotification,
    };
};

export default useTimedNotification;
